import {Typography} from 'components/Typography';
import {FilterSwitch} from 'plugins/modules/filter/components/FilterSwitch';
import {TFilterAloneCheckboxCustomView} from 'plugins/modules/filter/types';
import classNames from 'classnames';
import React, {FC, useEffect, useState} from 'react';
import style from './style.module.scss';
import {FilterHint} from 'plugins/modules/filter/components/FilterHint';

interface IProps {
    hint?: string;
    isDefaultChecked: boolean;
    onChange: (isChecked: boolean) => void;
    title: string;
    view: TFilterAloneCheckboxCustomView;
}

export const CheckboxAloneCustom: FC<IProps> = ({hint, isDefaultChecked, onChange, title, view}) => {
    const [currentIsDefaultChecked, setCurrentIsDefaultChecked] = useState(isDefaultChecked);
    const [isChecked, setIsChecked] = useState(isDefaultChecked);

    useEffect(() => {
        if (currentIsDefaultChecked === isDefaultChecked) {
            return;
        }

        setCurrentIsDefaultChecked(isDefaultChecked);
        setIsChecked(isDefaultChecked);
    }, [currentIsDefaultChecked, isDefaultChecked]);

    const handleChange = () => {
        const value = !isChecked;

        setIsChecked(value);
        onChange(value);
    };

    return (
        <label data-skeleton-item={true} className={classNames(style.main, {[style.isChecked]: isChecked})}>
            <input checked={isChecked} className={style.checkbox} onChange={handleChange} type={'checkbox'} />
            <img alt={''} className={style.image} src={`/images/${view}.png`} />
            <span className={style.contentBlock}>
                <span className={style.titleBlock}>
                    <Typography className={style.content} variant={'label-14-m'}>
                        {title}
                    </Typography>
                    {hint && <FilterHint text={hint} />}
                </span>
                <span className={style.switch}>
                    <FilterSwitch isChecked={isChecked} />
                </span>
            </span>
        </label>
    );
};
